import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../../api/apiClient";
import { Box, CircularProgress } from "@mui/material";

export default () => {


  const [compaing,setcompaing]=useState([])
  const [Loading,setLoading]=useState()
  const [search,setsearch]=useState("")
  const [sort,setsort]=useState("")

  const fetch = async () => {
    setLoading(true);
    const params = new URLSearchParams();

    // Add parameters
    if(search)
    params.append('search', search);
    if(sort)
    params.append('sort', sort);
   
      const response = await apiClient.get(`/campaign/campaigns/?` + params.toString());
      setLoading(false)

      if(!response.ok) return console.log("error")
      console.log("aucess")
      if (response.ok) {
        const data = response.data;
        // setnewreq(response?.data);
      console.log(response?.data)}
      setcompaing(response?.data)
 
      
  };




  useEffect(()=>{

    if(search===""||sort){
           fetch()
         }
  },[sort,search])
 





// useEffect(()=>{
//   if(search===""){
//     fetch()
//   }
// },[search])

  return (
    <div>
      <div className="site-content h-100">
        <div className="">
          <div className="site-content-body">
            <div className="container gx-0">
              <div className="row">
                <div className="col">
                  <div>
                    <div className="d-flex  justify-content-between main_bg_color pt-2 px-4">
                      <div className="d-md-flex gap-2 my-2">
                        <div className="d-flex pe-1 search_All_border rounded-pill mb-sm-0 mb-2">
                          <button onClick={fetch} className="bi-search searchbtn ps-4" />
                          <input
                            placeholder="search"
                            className="form-control search_input_width rounded-pill border-0 bi-search"
                            onChange={(e)=>setsearch(e.target.value)}

                          />
                        </div>
                        {/* <div className="dropdown d-flex justify-content-center justify-content-sm-start mt-2 mt-md-0">
                          <button
                            type="button"
                            className="btn bg-white rounded-pill d-flex sort_border px-4 mb-sm-0 mb-2"
                            data-bs-toggle="dropdown"
                          >
                            Sort{" "}
                            <i className="bi bi-filter-left my-auto ms-1 text-primary" />
                          </button>
                          <ul
                            className="dropdown-menu ps-3 text-primary fw-bold"
                            style={{ backgroundColor: "#EDEDED" }}
                          >
                            <li style={{cursor:"pointer"}}  onClick={()=>setsort("newest")} className="mb-3">Sort Date</li>
                            <li style={{cursor:"pointer"}}  onClick={(e)=>setsort("oldest")} className="mb-3">End Date</li>
                            <li style={{cursor:"pointer"}} className="mb-3">Sort A-Z</li>
                            <li style={{cursor:"pointer"}} className="mb-3">Sort Z-A</li>
                          </ul>
                        </div> */}
                      </div>
                      <Box className="col my-auto mx-2   list-group">
                        <div class="dropdown ">
                        <button
                            type="button"
                            className="btn bg-white rounded-pill d-flex sort_border px-4 mb-sm-0 mb-2"
                            data-bs-toggle="dropdown"
                          >
                            Sort{" "}
                            <i className="bi bi-filter-left my-auto ms-1 text-primary" />
                          </button>
                          <ul
                            class="dropdown-menu p-2 fw-bold"
                            style={{ color: "#015A96" }}
                          >
                           <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={()=>setsort("newest")}
                            >
                              Newest
                            </li>
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={(e)=>setsort("oldest")}
                            >
                              Oldest
                            </li>
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={(e)=>setsort("asc")}
                            >
                              Sort A-Z
                            </li>
                            <li
                              type="button"
                              className="list-group-item list-group-item-action"
                              onClick={(e)=>setsort("desc")}
                            >
                          
                            Sort Z-A
                            </li>
                       
                          </ul>
                        </div>
                      </Box>
                      {/* <div className="swich_button mt-md-0 mt-sm-3 mt-2 my-2">
                        <ul
                          className="nav rounded-pill tabs_posetion"
                          id="myTab"
                        >
                          <li>
                            <button
                              className=" btn btn_active rounded-pill fw-bold px-4 active "
                              id="home-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#home"
                              type="button"
                            >
                              ACTIVE
                            </button>
                          </li>
                          <li>
                            <button
                              className=" btn btn_active rounded-pill fw-bold px-4"
                              id="profile-tab"
                              data-bs-toggle="tab"
                              data-bs-target="#profile"
                              type="button"
                              role="tab"
                              aria-controls="profile"
                              aria-selected="false"
                            >
                              INACTIVE
                            </button>
                          </li>
                        </ul>
                      </div> */}
                    </div>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="home"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                      >
                        <div className="main_bg_color h-100">
                          <div className="container-fluid">
                            <div className="row py-3 ">
                              <div className=" col-lg-4 col-md-12 px-4 mb-5 d-flex gap-3 align-items-center  ">

                      

                                  <div className=" w-100">
                                  <Link to={"/vehicleowner-request"}>
                                    <div className="  card card_border_1">
                                      <div className="div_background_color_1 py-2">
                                        <h2 className="pb-3">
                                          New <br />
                                          Campaign
                                          <br />
                                          Request!
                                        </h2>
                                        <p className="px23">
                                          Click to see more details
                                        </p>
                                      </div>
                                      <div className="job_bg p-2 py-3">
                                        <p className="">
                                          Offer Expires: 12/9/22
                                        </p>
                                      </div>
                                    </div>
                                    {/* <div className="mt-2">
                              <button className="btn bg_button_color py-2 w-100 fs-5">Create
                                Request</button>
                            </div> */}
                                  </Link>
                                </div>
                                
                                  {/* <div
                                    style={{
                                      borderRight: "7px solid #868B8F",
                                      height: 120,
                                    }}
                                  ></div> */}
                              </div>
                              {Loading ? (
     
        <div className="text-center"><CircularProgress className="" /></div>
      ) :  
   (   compaing.map((e)=>{
  return(                      <div className=" col-lg-4 col-md-6 sm-col-12 px-4 mb-5 " key={e.id}>
                                    <Link to="/vehicleownercampaigns/detail" state={{id:e.bitrix_deal_id,vechile_id:e.id}}>
                                      <div>
                                        <div className=" card card_border div_posetion">
                                          <img
                                            className="card_img_top"
                                            src={e?.campaign_imag}
                                            alt="Card image"
                                            style={{
                                              width: "100%",
                                              height: "170px",
                                            }}
                                          />
                                          <div className="photo_button">
                                            <button className="px-4 py-2 rounded-pill border-0">
                                              {/* NIKE */}

                                            {e?.title}
                                        </button>
                                      </div>
                                      {/* <div className="nike_chat_icon"><i className="bi bi-chat-left-fill fa-2x" />
                                </div> */}
                                      <div className=" job_bg py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-1">
                                          Start Date:
                                          <span>{e?.start_date}</span>
                                        </p>
                                        <p className="mb-1">
                                          End Date:
                                          <span>{e?.end_date}</span>
                                        </p>
                                        {/* <p className="">
                                          vehicle:
                                          <span> 
                                            {e?.vehicles[0]},{e?.vehicles[1]}
                                          </span>
                                        </p> */}
                                      </div>
                                    </div>
                                  </div>
                                </Link>
                              </div>
)

}))

}

                              {/* <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_adidas.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "170px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        ADIDAS
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="mb-1">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p className="mb-1">
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                      <p>
                                        vehicle:
                                        <span> Isuzu,N-Serries</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="job_bg card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_waty.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "170px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        DISNEY
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p className="mb-0">
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                      <p className="">
                                        vehicle:<span> Isuzu,N-Serries</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="job_bg card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_hulu.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "170px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        HULU
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p className="mb-0">
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                      <p className="">
                                        vehicle:<span> Isuzu,N-Serries</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <div>
                                  <div className="card card_border div_posetion">
                                    <img
                                      className="card_img_top"
                                      src={require("../../assets/img/active_netflex.png")}
                                      alt="Card image"
                                      style={{ width: "100%", height: "170px" }}
                                    />
                                    <div className="photo_button">
                                      <button className="px-4 py-2 rounded-pill border-0">
                                        NETFLEX
                                      </button>
                                    </div>
                                    <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                      <p className="">
                                        Start Date:
                                        <span>01/08/2023</span>
                                      </p>
                                      <p className="mb-0">
                                        End Date: <span>05/20/2023</span>
                                      </p>
                                      <p className="">
                                        vehicle:<span> Isuzu,N-Serries</span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      
                      </div>
                      <div
                        className="tab-pane fade"
                        id="profile"
                        role="tabpanel"
                        aria-labelledby="profile-tab"
                      >
                        <div className="main_bg_color h-100">
                          <div className="container-fluid">
                            <div className="row py-3">
                              <div className=" col-lg-4 col-md-12 px-4 mb-5 d-flex gap-4 align-items-center  ">
                                <div className=" w-100">
                                  <Link to={"/vehicleownercampaigns/new"}>
                                    <div className="  card card_border_1">
                                      <div className="div_background_color_1 py-2">
                                        <h2 className="pb-3">
                                          New <br />
                                          Campaign
                                          <br />
                                          Request!
                                        </h2>
                                        <p className="px23">
                                          Click to see more details
                                        </p>
                                      </div>
                                      <div className="job_bg p-2 py-3">
                                        <p className="">
                                          Offer Expires: 12/9/22
                                        </p>
                                      </div>
                                    </div>
                                    {/* <div className="mt-2">
                              <button className="btn bg_button_color py-2 w-100 fs-5">Create
                                Request</button>
                            </div> */}
                                  </Link>
                                </div>
                                <div
                                  style={{
                                    borderRight: "7px solid #868B8F",
                                    height: 120,
                                  }}
                                ></div>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a>
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_nike.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          NIKE
                                        </button>
                                      </div>
                                      {/* <div className="nike_chat_icon">
                                        <i className="bi bi-chat-left-fill fa-2x" />
                                      </div> */}
                                      <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                        <p>
                                          Impressions:
                                          <span>1,123,9078</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a>
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_adidas.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          ADIDAS
                                        </button>
                                      </div>
                                      <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                        <p>
                                          Impressions:
                                          <span>1,123,9078</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a>
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_waty.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          DISNEY
                                        </button>
                                      </div>
                                      <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                        <p>
                                          Impressions:
                                          <span>1,123,9078</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a>
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_hulu.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          HULU
                                        </button>
                                      </div>
                                      <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                        <p>
                                          Impressions:
                                          <span>1,123,9078</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                              <div className="col-lg-4 col-md-12 px-4 mb-5">
                                <a>
                                  <div>
                                    <div className="card card_border div_posetion">
                                      <img
                                        className="card_img_top"
                                        src={require("../../assets/img/active_netflex.png")}
                                        alt="Card image"
                                        style={{
                                          width: "100%",
                                          height: "200px",
                                        }}
                                      />
                                      <div className="photo_button">
                                        <button className="px-4 py-2 rounded-pill border-0">
                                          NETFLEX
                                        </button>
                                      </div>
                                      <div className="job_bg card-body py-1 px-lg-2 px-md-1 px-2 top_border fs-6">
                                        <p className="mb-2">
                                          Start Date:
                                          <span>02/11/2023</span>
                                        </p>
                                        <p className="mb-2">
                                          End Date:
                                          <span>05/30/2023</span>
                                        </p>
                                        <p>
                                          Impressions:
                                          <span>1,123,9078</span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
// function Detail(props) {
//   return (
//     <Modal
//       {...props}
//       size="md"
//       aria-labelledby="contained-modal-title-vcenter"
//       centered
//     >
    
//       <Modal.Body>
//         <h5 style={{color:"#015A96"}}>Details:</h5>
//         <p>
//           Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
//           dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
//           consectetur ac, vestibulum at eros.
//         </p>
//       </Modal.Body>
   
//     </Modal>
//   );
// }